module.exports = __webpack_public_path__ + "img/circle.7e09b58b.svg";